<script setup lang="ts">
import type { InvestigationChapterCollectionItem } from '@nuxt/content'

const props = defineProps<{
  chapter: InvestigationChapterCollectionItem
}>()

const src = computed<string>(() => props.chapter.image?.src)
</script>

<template>
  <ULink as="div" :to="props.chapter.path" class="group flex flex-col rounded border  border-primary-200 bg-white group-hover:border-primary-500 dark:border-neutral-700 dark:bg-neutral-950 dark:hover:border-primary-600" exact-active-class="border-pink-200 outline-4 outline-offset-2 outline-pink-100">
    <div class="hidden h-44 overflow-hidden bg-primary-100 group-hover:bg-primary-600 lg:block dark:bg-neutral-300 dark:group-hover:bg-primary-300">
      <ImageCover :src="src" class="light:group-hover:mix-blend-overlay opacity-60 mix-blend-multiply grayscale group-hover:opacity-80 dark:opacity-80 dark:group-hover:opacity-90" />
    </div>
    <footer class="flex items-center border-t-primary-200 p-2 text-primary-700 group-hover:border-t-primary-500 group-hover:text-primary-900 lg:border-t  dark:border-t-neutral-700 dark:text-neutral-400 dark:group-hover:border-t-primary-500 dark:group-hover:text-neutral-300">
      <UIcon name="bx:book" class="mr-2 shrink-0" />
      <h2 class="text-pretty">
        {{ props.chapter.title }}
      </h2>
      <UIcon name="bx:chevron-right" class="ml-auto shrink-0" />
    </footer>
  </ULink>
</template>
